import { useSelector,useDispatch } from 'react-redux'
import { AspectRatio, Grid   } from '@mantine/core';

import intl from 'react-intl-universal';

import { clear_setclientlanguage, setdisplaywidth } from '../app/slice/mainslice';
import GuestShowDoc from './helper/GuestShowDoc';


/**
 * Generates the Guest User Video View component which displays the user's video view.
 * 
 * 
 * @guest_joinlink: {Object} - state.user.guest_joinlink - The cuurrent CMS link.
 * @guest_meinfo: {Object} - state.user.guest_meinfo - The current user.
 *  
 *
 * @return {JSX.Element} The JSX element representing the Guest User Video View component
 */

const GuestVideoView = () => {
  const dispatch = useDispatch()
  const guest_joinlink = useSelector((state: any) => state.user.guest_joinlink)

  const guest_meinfo = useSelector((state: any) => state.user.guest_meinfo)
  const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
  const displaywidth = useSelector((state: any) => state.user.displaywidth)

  //console.log(showdoc)

  // Build the language code for the join link
  let intoptions = intl.getInitOptions()


  let languagcode
  if (intoptions.currentLocale === "de_DE"){
    languagcode = "de-DE"
  }
  if (intoptions.currentLocale === "en_US"){
    languagcode = "en-US"
  }

  // Build the Dispaly Name for the join link
  let viewusername = guest_meinfo.firstName + " " + guest_meinfo.lastName
  let addtourl ="&name="+viewusername
  //let addskip = "&skipJoinOptions=true"
   let addskip = ""

  let splitjoinlink
  let joinlink = ""
  let meetingpart

  try {
    if (guest_joinlink !== undefined){
    // Build the full join link
    if (joinlink === "") {
     splitjoinlink = guest_joinlink.joinLink.split('meeting/')
     meetingpart = splitjoinlink[1].split('?')
     let languagepart = languagcode+"/meeting/";
     joinlink = splitjoinlink[0]+languagepart+meetingpart[0]+"?secret="+addtourl
     //joinlink = splitjoinlink[0]+languagepart+splitjoinlink[1]
    }
	} else {
		throw new Error ("CMS Link is empty");
	}
  } catch (e) {
	   console.log(e);
  } finally {
   // Fallback to default CMS join link
    if (joinlink === undefined){
      joinlink = "https://join.uc-lab.lilenium.com/meeting/"
    }
  }  

  //console.log(showdoc.resourceId)


// Prepare the Display depending on Viewtype
// Differnet between DocRead and DocSign and VideoView
// Prepare the Display depending on Viewtype
// Differnet between DocRead and DocSign and VideoView
let ratio:number = 16 / 9;
let gridwidth = 12


if (showdoc.resourceId !== undefined){

  if (displaywidth === 1){
    ratio = 70 / 9;
  }
  if (displaywidth === 2){
    gridwidth = 6;
  }
}

 // Check ob ein Dokument angezeigt wird; wenn nein das Fenste wieder auf 100% setzten
 if (showdoc.resourceId === undefined){
  if (displaywidth === 6){
    dispatch(setdisplaywidth(12))
  }
}

 
return (
<>
<Grid>
    <Grid.Col span={gridwidth}>
      <AspectRatio ratio={ratio} sx={{ maxWidth: 1920 }} mx="auto">
          <iframe
            //src="https://join.uc-lab.lilenium.com/meeting/"
            src={joinlink}
            title={"Testraum"}
            allow="camera;microphone;display-capture"
            allowFullScreen
            frameBorder= "0"
          />
      </AspectRatio>
    </Grid.Col>
    <Grid.Col span={gridwidth}>
    {showdoc.resourceId !== undefined &&
       <GuestShowDoc resourceId={showdoc.resourceId} />
      }
    </Grid.Col>

     
  </Grid>
</> 
  );
}


export default GuestVideoView ;